/*
 * Copyright (C) 2024 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { ZustaendigeStelleSharedModule } from '@alfa-client/zustaendige-stelle-shared';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InstantSearchEditorComponent } from '@odc/component';
import { ButtonComponent, IconComponent, SearchResultItemComponent } from '@ods/system';
import { EditZustaendigeStelleButtonComponent } from './edit-zustaendige-stelle-button/edit-zustaendige-stelle-button.component';
import { SearchExterneFachstelleContainerComponent } from './search-externe-fachstelle-container/search-externe-fachstelle-container.component';
import { SearchOrganisationsEinheitContainerComponent } from './search-organisations-einheit-container/search-organisations-einheit-container.component';
import { SearchZustaendigeStelleDialogComponent } from './search-zustaendige-stelle-dialog/search-zustaendige-stelle-dialog.component';
import { SearchZustaendigeStelleFormContainerComponent } from './search-zustaendige-stelle-dialog/search-zustaendige-stelle-form-container/search-zustaendige-stelle-form-container.component';
import { SearchZustaendigeStelleFormComponent } from './search-zustaendige-stelle-dialog/search-zustaendige-stelle-form-container/search-zustaendige-stelle-form/search-zustaendige-stelle-form.component';
import { SearchZustaendigeStelleResultItemComponent } from './search-zustaendige-stelle-dialog/search-zustaendige-stelle-form-container/search-zustaendige-stelle-form/search-zustaendige-stelle-result-items/search-zustaendige-stelle-result-item/search-zustaendige-stelle-result-item.component';
import { SearchZustaendigeStelleResultItemsComponent } from './search-zustaendige-stelle-dialog/search-zustaendige-stelle-form-container/search-zustaendige-stelle-form/search-zustaendige-stelle-result-items/search-zustaendige-stelle-result-items.component';
import { ZustaendigeStelleButtonComponent } from './zustaendige-stelle-button/zustaendige-stelle-button.component';
import { ZustaendigeStelleHeaderComponent } from './zustaendige-stelle-header/zustaendige-stelle-header.component';

@NgModule({
  imports: [
    CommonModule,
    ButtonComponent,
    InstantSearchEditorComponent,
    FormsModule,
    ReactiveFormsModule,
    ZustaendigeStelleSharedModule,
    IconComponent,
    SearchResultItemComponent,
  ],
  declarations: [
    SearchOrganisationsEinheitContainerComponent,
    SearchZustaendigeStelleFormComponent,
    SearchZustaendigeStelleDialogComponent,
    ZustaendigeStelleButtonComponent,
    SearchExterneFachstelleContainerComponent,
    EditZustaendigeStelleButtonComponent,
    ZustaendigeStelleHeaderComponent,
    SearchZustaendigeStelleFormContainerComponent,
    SearchZustaendigeStelleResultItemsComponent,
    SearchZustaendigeStelleResultItemComponent,
  ],
  exports: [
    SearchZustaendigeStelleFormComponent,
    SearchZustaendigeStelleDialogComponent,
    SearchOrganisationsEinheitContainerComponent,
    SearchExterneFachstelleContainerComponent,
    SearchZustaendigeStelleFormContainerComponent,
  ],
})
export class ZustaendigeStelleModule {}
